import React, { Component } from 'react';
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import { BASE_URL, sessionExpireMessage, toastError, toastSuccess, tokenInavlidMessage } from '../../../utils/constants'
import Header from '../../../common_components/Header';
import Loader from '../../../utils/Loader';
import { get_eventMaster_details_action, insertUpdate_eventMaster_action } from '../../../actions/adminAction/event_master_action';
import Resizer from "react-image-file-resizer";
import { Button, Modal, Nav, Tab } from 'react-bootstrap';
class eventMasterDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            EventID: '',
            Title: '',
            URL: '',
            EventFromDate: '',
            EventToDate: '',
            Address: '',
            Description: '',
            filename: '',
            filetype: '',
            formfile: '',
            FilePath: '',
            FilePreview: '',
            SeqNo: '', navSeqNo: '',
            PriceInr: null, PriceUsd: null,
            // ERROR
            TitleErr: '',
            URLErr: '',
            EventFromDateErr: '',
            EventToDateErr: '',
            AddressErr: '',
            FilePathErr: '',
            PriceInrErr: '', PriceUsdErr: '',
            attachmentErr: '',
            downloadUrl: '',
            isMemberDashboard: 0,
            tabSelected: 'EM',
            isDraft: 0,
            MemberList: [],
            filteredMemberList: [],
            checkedMemberList: [],

            searchedMemberName: '',
            searchedEmailAddress: '',
            searchedChapterName: '',
            searchedState: '',
            isEmailModalOpen: false
        }
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem("loginDataSS")) == null) {
            setTimeout(() => {
                this.props.navigate('/');
            }, 200);
        } else {
            window.scrollTo(0, 0)
            const EventID = this.props.location?.state?.EventID ?? null;
            const navSeqNo = this.props.location?.state?.seqNo
            this.setState({ EventID: EventID, navSeqNo: navSeqNo }, () => {
                this.getEventMasterDetails(EventID, 0, 0)
            })
            const sortUrl = BASE_URL.split("/api");
            this.setState({ downloadUrl: sortUrl[0] });
        }
    }
    getEventMasterDetails(EventID, isMemberDashboard, tabShift) {
        console.log("getEventMasterDetails", EventID, isMemberDashboard)

        this.setState({ isLoading: true })
        this.props.get_eventMaster_details_action(EventID ? EventID : null, isMemberDashboard ? isMemberDashboard : 0)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    const eventData = data?.data?.[0]?.[0];
                    this.setState({
                        EventID: eventData?.EventID,
                        Title: eventData?.Title,
                        URL: eventData?.URL,
                        EventFromDate: eventData?.EventFromDate,
                        EventToDate: eventData?.EventToDate,
                        Address: eventData?.Address,
                        Description: eventData?.Description,
                        FilePath: eventData?.FilePath,
                        SeqNo: eventData?.SeqNo,
                        PriceInr: eventData?.PriceInr,
                        PriceUsd: eventData?.PriceUsd,
                        isMemberDashboard: tabShift == 1 ? isMemberDashboard : eventData?.isMemberDashboard,
                        tabSelected: tabShift == 1 ? (isMemberDashboard == 1 ? 'UD' : 'EM') : (eventData?.isMemberDashboard == true ? 'UD' : 'EM'),
                        isDraft: eventData?.isDraft ? eventData?.isDraft : 0,
                        MemberList: data?.data?.[1]?.map(m => ({ ...m, isSelect: false })),
                        filteredMemberList: data?.data?.[1]?.map(m => ({ ...m, isSelect: false }))
                    })

                    this.setState({ isLoading: false })
                } else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear();
                        this.props.navigate("/");
                        setTimeout(() => {
                            toastError(data.msg);
                        }, 2000);
                    } else {
                        toastError(data.data);
                    }
                    this.setState({ isLoading: false })
                    toastError(data?.data?.ErrorMsg);
                }
            })
    }

    insertUpdateEvent(isDraft) {
        const { EventID, Title, URL, EventFromDate, EventToDate, Address, Description, filename, filetype, formfile, FilePath,
            SeqNo, navSeqNo, PriceInr, PriceUsd, isMemberDashboard, checkedMemberList } = this.state
        if (isDraft == 0 && EventID == null && checkedMemberList.length == 0) {
            toastError("Please select at least one member to send email.");
            return;
        }
        this.inputValidation().then(res => {
            if (!res) {
                this.setState({ isLoading: true })
                this.props
                    .insertUpdate_eventMaster_action(EventID, Title, URL, EventFromDate, EventToDate, Address, Description, filename, filetype, formfile, FilePath,
                        EventID ? SeqNo : navSeqNo, PriceInr, PriceUsd, isMemberDashboard, isDraft, checkedMemberList)
                    .then((data) => {
                        if (data.error != 1) {
                            if (data.data.ErrorMsg == null) {
                                this.setState({ isLoading: false }, () => toastSuccess('Submitted Successfully'))
                                setTimeout(() => {
                                    this.props.navigate('/event_master_list')
                                }, 500);
                            } else {
                                this.setState({ isLoading: false })
                                toastError(data.data.ErrorMsg);
                            }
                        } else {
                            if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                                sessionStorage.clear();
                                this.props.navigate("/");
                                setTimeout(() => {
                                    toastError(data.msg);
                                }, 2000);
                            } else {
                                toastError(data.data);
                            }
                            this.setState({ isLoading: false })
                            toastError(data.msg);
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            } else {
                toastError("Please enter mandatory fields")
            }
        })
    }

    inputValidation() {
        const { Title, URL, EventFromDate, EventToDate, Address, PriceInr, PriceUsd, FilePath, formfile, isMemberDashboard } = this.state
        var Err = false
        return new Promise((resolve) => {
            if (Title == '' || Title == null) {
                Err = true
                this.setState({ TitleErr: 'Please enter Title' })
            }
            // if (URL == '' || URL == null) {
            //     Err = true
            //     this.setState({ URLErr: 'Please enter URL' })
            // }
            // if (EventFromDate == '' || EventFromDate == null) {
            //     Err = true
            //     this.setState({ EventFromDateErr: 'Please enter From Date' })
            // }
            // if (EventToDate == '' || EventToDate == null) {
            //     Err = true
            //     this.setState({ EventToDateErr: 'Please enter From Date' })
            // }
            // if (Address == '' || Address == null) {
            //     Err = true
            //     this.setState({ AddressErr: 'Please enter Address' })
            // } if (PriceInr == '' || PriceInr == null) {
            //     Err = true
            //     this.setState({ PriceInrErr: 'Please enter Price Inr' })
            // } if (PriceUsd == '' || PriceUsd == null) {
            //     Err = true
            //     this.setState({ PriceUsdErr: 'Please enter Price Usd' })
            // } 
            if (isMemberDashboard == 0) {
                if (!FilePath && !formfile) {
                    Err = true;
                    this.setState({ FilePathErr: 'Please select an event logo.' });
                }
            } else {
                if (URL == '' || URL == null) {
                    if (!FilePath && !formfile) {
                        Err = true;
                        toastError("Please enter URL or attach file");
                        this.setState({ attachmentErr: 'Please enter url or attach file' });
                    }
                }
            }
            resolve(Err)
        })
    }


    navigateBackEventList() {
        this.props.navigate('/event_master_list')
    }
    handleImageUpload = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Validate size
        if (file.size > 5 * 1024 * 1024) {
            toastError("File size more than 5MB is not allowed.");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        // Validate file type
        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            toastError("Only .jpeg, .png, .jpg files are allowed");
            e.target.value = null; // prevent accepting the file
            this.clearFileInput();
            return;
        }

        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        this.setState({
            FilePath: '',
            FilePreview: image,
            filename: file.name,
            filetype: fileExtension,
            formfile: image.split(',')[1], // remove base64 prefix
            FilePathErr: ''
        });
    };

    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
                file, 500, 600, "JPEG", 80, 0,
                (uri) => { resolve(uri); },
                "base64", 300, 300);
        });

    clearFileInput = () => {
        this.setState({
            FilePath: null,
            filename: '',
            filetype: '',
            formfile: '',
            FilePreview: ''
        });
    };
    clearTabShift = (isMemberDashboard) => {
        this.setState({
            FilePath: null, filename: '', filetype: '', formfile: '', FilePreview: '', FilePath: '',
            Title: '', URL: '', EventFromDate: '', EventToDate: '', Address: '', Description: '',
            TitleErr: '', URLErr: '', EventFromDateErr: '', EventToDateErr: '', AddressErr: '', FilePathErr: '',
            PriceInr: null, PriceUsd: null, PriceInrErr: '', PriceUsdErr: '',
            currentPage: 1, isMemberDashboard: isMemberDashboard,
            tabSelected: isMemberDashboard == 0 ? 'EM' : 'UD'
        });
        this.getEventMasterDetails(this.state.EventID ?? null, isMemberDashboard, 1);
    }
    toggleModalEmail = (isDraft) => {
        this.setState({ isDraft: isDraft, isEmailModalOpen: !this.state.isEmailModalOpen })
    }
    filterMemberList = () => {
        const {
            MemberList,
            searchedMemberName,
            searchedEmailAddress,
            searchedChapterName,
            searchedState,
        } = this.state;

        const filtered = MemberList.filter((member) => {
            return (
                (!searchedMemberName || member.CompanyName?.toLowerCase().includes(searchedMemberName.toLowerCase())) &&
                (!searchedEmailAddress || member.EmailAddress?.toLowerCase().includes(searchedEmailAddress.toLowerCase())) &&
                (!searchedChapterName || member.ChapterName?.toLowerCase().includes(searchedChapterName.toLowerCase())) &&
                (!searchedState || member.State?.toLowerCase().includes(searchedState.toLowerCase()))
            );
        });

        this.setState({ filteredMemberList: filtered });
    };

    clearFilterMemberList = () => {
        this.setState({
            searchedMemberName: '',
            searchedEmailAddress: '',
            searchedChapterName: '',
            searchedState: '',
            filteredMemberList: this.state.MemberList,
        });
    };

    toggleCheckbox = (memberId) => {
        const { filteredMemberList } = this.state;
        const updatedList = filteredMemberList.map(m => {
            if (m.MemberID === memberId) {
                return { ...m, isSelect: !m.isSelect };
            }
            return m;
        });

        this.setState({
            filteredMemberList: updatedList,
            checkedMemberList: updatedList.filter(m => m.isSelect)
        });
    };


    toggleSelectAll = () => {
        const { filteredMemberList } = this.state;

        const allSelected = filteredMemberList.every(m => m.isSelect);

        const updatedList = filteredMemberList.map(m => ({
            ...m,
            isSelect: !allSelected
        }));

        this.setState({
            filteredMemberList: updatedList,
            checkedMemberList: updatedList.filter(m => m.isSelect)
        });
    };


    render() {
        const { isLoading, Title, URL, EventFromDate, EventToDate, Address, Description,
            TitleErr, FilePreview, isDraft, FilePath, PriceInr, PriceUsd, FilePathErr,
            EventID, isMemberDashboard, tabSelected, attachmentErr, isEmailModalOpen, MemberList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                {/* <ToastContainer />. */}
                <Header />
                <ToastContainer />
                <section class="registration_form">
                    <div class="container">
                        <h6 className='pt-2'>Event Master Details</h6>
                        <div class="row mt-15">
                            <div class="col-md-12">
                                <div class="row">
                                    <div class="col-md-12">
                                        <Tab.Container activeKey={tabSelected}>
                                            <Nav variant="tabs" role="tablist"
                                                className="nav nav-tabs nav-tabs-custom nav-success mb-3">
                                                {(EventID && isMemberDashboard == 1) ? <></> : <>
                                                    <Nav.Item>
                                                        <Nav.Link eventKey={'EM'}
                                                            onClick={() => {
                                                                this.clearTabShift(0)
                                                            }}
                                                        >Event Master
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                </>}
                                                {(EventID && isMemberDashboard == 0) ? <></> : <>

                                                    <Nav.Item>
                                                        <Nav.Link eventKey={'UD'}
                                                            onClick={() => {
                                                                this.clearTabShift(1)
                                                            }}
                                                        >User Dashboard
                                                        </Nav.Link>
                                                    </Nav.Item>
                                                </>}
                                            </Nav>
                                            <Tab.Content>
                                                <Tab.Pane eventKey={'EM'}>
                                                    <div class="custom_tabs" id="mytabs">
                                                        <div class="tab-content">
                                                            <div class="tab-pane active" id="Company_Profile_tab" role="tabpanel" aria-labelledby="Company_Profile_tab" tabindex="0">
                                                                <fieldset>
                                                                    <legend className='mb-0 pb-0'>Event Details</legend>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <div class="row mb-3">
                                                                                <div class="col-md-3">
                                                                                    <div class="form-group">
                                                                                        <label>Event Name<span className="red-star text-danger">*</span></label>
                                                                                        <input type="text" class="form-control" placeholder="Enter Title" value={Title} onChange={(e) => this.setState({ Title: e.target.value, TitleErr: '' })} maxLength={200} />
                                                                                        {<span className='text-danger text-start text-left d-block  ml-2'>{TitleErr}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-3">
                                                                                    <div className="form-group">
                                                                                        <label>From Date
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <input
                                                                                            type="date"
                                                                                            className="form-control"
                                                                                            placeholder="From Date"
                                                                                            value={EventFromDate ? EventFromDate.substring(0, 10) : ''}
                                                                                            onChange={(e) => {
                                                                                                const newFromDate = e.target.value;

                                                                                                // If newFromDate and EventToDate are both set, validate
                                                                                                if (newFromDate && EventToDate && newFromDate > EventToDate) {
                                                                                                    toastError('From Date should be less than or equal to To Date');
                                                                                                    return;
                                                                                                }

                                                                                                this.setState({
                                                                                                    EventFromDate: newFromDate,
                                                                                                    EventFromDateErr: '',
                                                                                                    EventToDateErr: ''
                                                                                                });
                                                                                            }}
                                                                                        />

                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{EventFromDateErr}</span>} */}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-md-3">
                                                                                    <div className="form-group">
                                                                                        <label>To Date
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <input
                                                                                            type="date"
                                                                                            className="form-control"
                                                                                            placeholder="To Date"
                                                                                            value={EventToDate ? EventToDate.substring(0, 10) : ''}
                                                                                            onChange={(e) => {
                                                                                                const newToDate = e.target.value;

                                                                                                // If newToDate and EventFromDate are both set, validate
                                                                                                if (newToDate && EventFromDate && newToDate < EventFromDate) {
                                                                                                    toastError('To Date should be greater than or equal to From Date');
                                                                                                    return;
                                                                                                }

                                                                                                this.setState({
                                                                                                    EventToDate: newToDate,
                                                                                                    EventToDateErr: '',
                                                                                                    EventFromDateErr: ''
                                                                                                });
                                                                                            }}
                                                                                        />

                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{EventToDateErr}</span>} */}
                                                                                    </div>
                                                                                </div>

                                                                                <div class="col-md-3">
                                                                                    <div class="form-group">
                                                                                        <label>Event Link
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <input type="text" class="form-control" placeholder="Enter Link" value={URL} onChange={(e) => this.setState({ URL: e.target.value, URLErr: '' })} maxLength={200} />
                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{URLErr}</span>} */}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-3">
                                                                                    <div className="form-group">
                                                                                        <label>Price (INR)
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <input
                                                                                            type="text"
                                                                                            maxLength={20}
                                                                                            className="form-control"
                                                                                            placeholder="Price INR"
                                                                                            value={PriceInr}
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;
                                                                                                const regex = /^\d*\.?\d{0,2}$/; // Allows decimals (up to 2 digits if needed)

                                                                                                if (value === '' || regex.test(value)) {
                                                                                                    this.setState({ PriceInr: value, PriceInrErr: '' });
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{PriceInrErr}</span>} */}
                                                                                    </div>
                                                                                </div>

                                                                                <div className="col-md-3">
                                                                                    <div className="form-group">
                                                                                        <label>Price (USD)
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <input
                                                                                            type="text"
                                                                                            maxLength={20}
                                                                                            className="form-control"
                                                                                            placeholder="Price USD"
                                                                                            value={PriceUsd}
                                                                                            onChange={(e) => {
                                                                                                const value = e.target.value;
                                                                                                const regex = /^\d*\.?\d{0,2}$/;

                                                                                                if (value === '' || regex.test(value)) {
                                                                                                    this.setState({ PriceUsd: value, PriceUsdErr: '' });
                                                                                                }
                                                                                            }}
                                                                                        />
                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{PriceUsdErr}</span>} */}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label>Event Address
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <textarea type="text" cols={2} class="form-control" placeholder="Enter Address" value={Address} onChange={(e) => this.setState({ Address: e.target.value, AddressErr: '' })} maxLength={200} ></textarea>
                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{AddressErr}</span>} */}
                                                                                    </div>
                                                                                </div>
                                                                                <div class="col-md-6">
                                                                                    <div class="form-group">
                                                                                        <label>Event Description</label>
                                                                                        <textarea type="text" cols={2} class="form-control" placeholder="Enter Description" value={Description} onChange={(e) => this.setState({ Description: e.target.value, DescriptionErr: '' })} maxLength={1000} ></textarea>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-6">
                                                                                    <div className="form-group">
                                                                                        <label>
                                                                                            Event Logo <span className="red-star text-danger">* (Allowed: .jpeg, .png, .jpg - max 5MB)</span>
                                                                                        </label>

                                                                                        {(FilePath ? FilePath : FilePreview) ? (
                                                                                            <div style={{ position: "relative", display: "inline-block" }}>
                                                                                                <img
                                                                                                    src={FilePath ? FilePath : FilePreview}
                                                                                                    alt="Preview"
                                                                                                    style={{ width: "250px", height: "250px", objectFit: "contain", border: "1px solid #ccc" }}
                                                                                                />
                                                                                                <button
                                                                                                    type="button"
                                                                                                    onClick={this.clearFileInput}
                                                                                                    style={{
                                                                                                        position: "absolute",
                                                                                                        top: "-8px",
                                                                                                        right: "-8px",
                                                                                                        background: "#dc3545",
                                                                                                        color: "#fff",
                                                                                                        border: "none",
                                                                                                        borderRadius: "50%",
                                                                                                        width: "24px",
                                                                                                        height: "28px",
                                                                                                        cursor: "pointer",
                                                                                                        fontSize: "14px"
                                                                                                    }}
                                                                                                    title="Remove"
                                                                                                >
                                                                                                    X
                                                                                                </button>
                                                                                            </div>
                                                                                        ) : (<>
                                                                                            <input
                                                                                                type="file"
                                                                                                accept="image/jpeg, image/png, image/jpg"
                                                                                                className="form-control"
                                                                                                placeholder="Upload Logo"
                                                                                                onChange={this.handleImageUpload}
                                                                                                ref={(ref) => (this.fileInputRef = ref)}
                                                                                            />
                                                                                            {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{FilePathErr}</span>}
                                                                                        </>
                                                                                        )}

                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </fieldset>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab.Pane>
                                                <Tab.Pane eventKey={'UD'}>
                                                    <div class="custom_tabs" id="mytabs">
                                                        <div class="tab-content">
                                                            <div class="tab-pane active" id="Company_Profile_tab" role="tabpanel" aria-labelledby="Company_Profile_tab" tabindex="0">
                                                                <fieldset>
                                                                    <legend className='mb-0 pb-0'>User Dashboard</legend>
                                                                    <div class="row">
                                                                        <div class="col-md-12">
                                                                            <div class="row mb-3">
                                                                                <div class="col-md-4">
                                                                                    <div class="form-group">
                                                                                        <label>Card Title<span className="red-star text-danger">*</span></label>
                                                                                        <input type="text" class="form-control" placeholder="Enter Title" value={Title} onChange={(e) => this.setState({ Title: e.target.value, TitleErr: '' })} maxLength={200} />
                                                                                        {<span className='text-danger text-start text-left d-block  ml-2'>{TitleErr}</span>}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="form-group">
                                                                                        <label>Highlight Until
                                                                                            {/* <span className="red-star text-danger">*</span> */}
                                                                                        </label>
                                                                                        <input
                                                                                            type="date"
                                                                                            className="form-control"
                                                                                            placeholder="To Date"
                                                                                            value={EventToDate ? EventToDate.substring(0, 10) : ''}
                                                                                            onChange={(e) => {
                                                                                                const newToDate = e.target.value;

                                                                                                this.setState({
                                                                                                    EventToDate: newToDate,
                                                                                                    EventToDateErr: '',
                                                                                                    EventFromDateErr: ''
                                                                                                });
                                                                                            }}
                                                                                        />

                                                                                        {/* {<span className='text-danger text-start text-left d-block  ml-2'>{EventToDateErr}</span>} */}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4" />
                                                                                <div className="col-md-4">
                                                                                    <div className="form-group">
                                                                                        <label>Document Link</label>
                                                                                        <div className="d-flex align-items-center">
                                                                                            <input
                                                                                                type="text"
                                                                                                className="form-control"
                                                                                                disabled={isMemberDashboard == 1 && (FilePath || FilePreview)}
                                                                                                placeholder="Enter Link"
                                                                                                value={URL}
                                                                                                onChange={(e) => this.setState({ URL: e.target.value, URLErr: '' })}
                                                                                                maxLength={200}
                                                                                            />
                                                                                            <span className="text-danger" style={{ marginLeft: '15px' }}> OR</span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="col-md-4">
                                                                                    <div className="form-group">
                                                                                        <label>Attachment <span className="red-star text-danger"> (Allowed: .jpeg, .png, .jpg, .pdf - max 5MB)</span></label>

                                                                                        {(FilePath ? FilePath : FilePreview) ? (
                                                                                            <div style={{ position: "relative", display: "inline-block" }}>
                                                                                                <img
                                                                                                    src={FilePath ? FilePath : FilePreview}
                                                                                                    alt="Preview"
                                                                                                    style={{ width: "250px", height: "250px", objectFit: "contain", border: "1px solid #ccc" }}
                                                                                                />
                                                                                                <button type="button" onClick={this.clearFileInput}
                                                                                                    style={{
                                                                                                        position: "absolute", top: "-8px", right: "-8px",
                                                                                                        background: "#dc3545", color: "#fff", border: "none",
                                                                                                        borderRadius: "50%", width: "24px", height: "28px",
                                                                                                        cursor: "pointer", fontSize: "14px"
                                                                                                    }}
                                                                                                    title="Remove">X</button>
                                                                                            </div>
                                                                                        ) : (<>
                                                                                            <input type="file"
                                                                                                accept="image/jpeg, image/png, image/jpg, application/pdf"
                                                                                                className="form-control"
                                                                                                placeholder="Upload Logo"
                                                                                                disabled={isMemberDashboard == 1 && URL}
                                                                                                onChange={this.handleImageUpload}
                                                                                                ref={(ref) => (this.fileInputRef = ref)}
                                                                                            />
                                                                                            {<span className='text-danger text-start d-block ml-2' style={{ fontSize: 'smaller' }}>{FilePathErr}</span>}
                                                                                        </>
                                                                                        )}
                                                                                    </div>
                                                                                </div>

                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </fieldset>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Tab.Pane>
                                            </Tab.Content>
                                        </Tab.Container>
                                        <div class="row">
                                            <div class="col-md-12 text-right">
                                                {(
                                                    (!this.state.EventID && this.state.isDraft === 0 && this.state.isMemberDashboard === 1) ||
                                                    (this.state.EventID && this.state.isDraft === 1 && this.state.isMemberDashboard === 1)
                                                ) && (
                                                        <button className="btn btn-primary next_btn mx-2"
                                                            onClick={() => this.insertUpdateEvent(1)}
                                                        >
                                                            Save as Draft
                                                        </button>
                                                    )}
                                                <button class="btn btn-primary next_btn mx-2"
                                                    onClick={() => this.navigateBackEventList()}
                                                >Back</button>
                                                <button class="btn btn-primary next_btn"
                                                    onClick={() => {
                                                        if (EventID) {
                                                            this.insertUpdateEvent(0);
                                                        } else {
                                                            this.inputValidation().then(res => {
                                                                if (!res) this.toggleModalEmail(0)
                                                            })
                                                        }
                                                    }}
                                                >{EventID ? 'Update' : 'Save'}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </section >
                <Modal show={isEmailModalOpen} onHide={this.toggleModalEmail} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Email Notification</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ul className="list-group list-group-flush">
                            <li className="list-group-item">
                                <div className="row">
                                    {/** Search Fields **/}
                                    {['MemberName', 'EmailAddress', 'ChapterName', 'State'].map((field, i) => (
                                        <div className="col-md-2" key={i}>
                                            <div className="form-group">
                                                <label>{field.replace(/([A-Z])/g, ' $1')}</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={`Enter ${field}`}
                                                    value={this.state[`searched${field}`]}
                                                    onChange={(e) =>
                                                        this.setState({ [`searched${field}`]: e.target.value })
                                                    }
                                                    maxLength={200}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                    {/** Buttons **/}
                                    <div className="col-xl-2 mb-2">
                                        <button
                                            style={{ marginTop: '20px', marginRight: '10px' }}
                                            className="btn btn-primary"
                                            onClick={this.filterMemberList}
                                        >
                                            Search
                                        </button>
                                        <button
                                            type="button"
                                            style={{ marginTop: '20px' }}
                                            className="btn btn-dark"
                                            onClick={this.clearFilterMemberList}
                                        >
                                            Clear
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        {/** Table **/}
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-bordered table-striped mb-0">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>
                                                    <div className="form-group mb-0">
                                                        <div className="custom-control custom-checkbox" onClick={() => this.toggleSelectAll()}>
                                                            <input
                                                                type="checkbox"
                                                                className="custom-control-input"
                                                                checked={
                                                                    this.state.filteredMemberList?.length > 0 &&
                                                                    this.state.filteredMemberList.every(m => m.isSelect)
                                                                }
                                                                value={this.state.filteredMemberList?.length > 0 &&
                                                                    this.state.filteredMemberList.every(m => m.isSelect)}
                                                            />
                                                            <label className="custom-control-label" >&nbsp;</label>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th>Company Name</th>
                                                <th>Email Address</th>
                                                <th>Chapter Name</th>
                                                <th>State</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    {console.log(this.state.checkedMemberList, 'checkedMemberList')}
                                    <div style={{ height: '20rem', overflowY: 'auto' }}>
                                        <table className="table table-bordered table-striped mb-0">
                                            <tbody>
                                                {this.state.filteredMemberList?.length > 0 ? (
                                                    this.state.filteredMemberList.map((member, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <div className="form-group mb-0">
                                                                    <div className="custom-control custom-checkbox" onClick={() => this.toggleCheckbox(member.MemberID)}>
                                                                        <input
                                                                            type="checkbox"
                                                                            className="custom-control-input"
                                                                            checked={member.isSelect}
                                                                            value={member.isSelect}
                                                                        />
                                                                        <label className="custom-control-label">&nbsp;</label>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td>{member.CompanyName}</td>
                                                            <td>{member.EmailAddress}</td>
                                                            <td>{member.ChapterName}</td>
                                                            <td>{member.State}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center">No members found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.toggleModalEmail}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={() => this.insertUpdateEvent(0)}>
                            Save & Send Email
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}

export default withRouter(connect(null, { get_eventMaster_details_action, insertUpdate_eventMaster_action })(eventMasterDetail));
